// Possible chromosome options used for variant/genotype search inputs
const Chromosomes = [
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11',
  '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22',
  'X', 'Y'
];

export default Chromosomes;
